// src/components/Header.js
import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import TeamLogo from '../assessts/lightX.PNG'; // Replace with your actual logo path
import './Header.css';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // Close the mobile menu when resizing to desktop
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768) {
                setIsMenuOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="navbar-container">
            <div className="navbar">
                <div className="navbar-left">
                    <img src={TeamLogo} alt="Team Logo" className="team-logo" />
                    <div className="team-text">                    
                        <h1 className="team-name">WOOD FC</h1>
                        <h3 className="team-slogan">Raise up Communities, Not Just Trophies</h3>
                    </div>
                </div>
                <nav className="navbar-right">
                    {/* Desktop Menu Links */}
                    <ul className="desktop-menu">
                        <li><RouterLink to="/">Home</RouterLink></li>
                        <li><RouterLink to="/hall-of-wood">Hall of Wood</RouterLink></li>
                        <li><ScrollLink to="about-section" smooth={true} duration={500}>About</ScrollLink></li>
                        <li><ScrollLink to="players-section" smooth={true} duration={500}>Players</ScrollLink></li>
                        <li><ScrollLink to="contact-section" smooth={true} duration={500}>Contact</ScrollLink></li>
                    </ul>

                    {/* Hamburger Icon for Mobile */}
                    <div className="hamburger" onClick={toggleMenu}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>

                    {/* Mobile Menu Links */}
                    <ul className={`menu-links ${isMenuOpen ? 'open' : ''}`}>
                        <li><RouterLink to="/" onClick={toggleMenu}>Home</RouterLink></li>
                        <li><RouterLink to="/hall-of-wood" onClick={toggleMenu}>Hall of Wood</RouterLink></li>
                        <li><ScrollLink to="about-section" smooth={true} duration={500} onClick={toggleMenu}>About</ScrollLink></li>
                        <li><ScrollLink to="players-section" smooth={true} duration={500} onClick={toggleMenu}>Players</ScrollLink></li>
                        <li><ScrollLink to="contact-section" smooth={true} duration={500} onClick={toggleMenu}>Contact</ScrollLink></li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;